module.exports = __webpack_public_path__ + "static/media/add-head.489b8cfd.jpg";